var map = {
	"./icon-arrow.svg": 51089,
	"./icon-change.svg": 49503,
	"./icon-close.svg": 50829,
	"./icon-copy.svg": 54171,
	"./icon-edit.svg": 47766,
	"./icon-fill-ok.svg": 62755,
	"./icon-lfg.svg": 54012,
	"./icon-lock.svg": 20111,
	"./icon-ok.svg": 35686,
	"./icon-refresh.svg": 82037,
	"./icon-telegram.svg": 45810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;